<template>
  <div class="modal-window ProjectManagewrap">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("title.ProjectSetting.002","과제 정보관리")}}</div>
      <button @click="closePopup" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="tab_ty1" id="tabsTy1">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy1"
            v-bind:class="{ active: currentTab1 === index }"
          >
            <button type="button" v-on:click="tabsClick(index)">
              {{ tab }}
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <ProjectManage v-show="currentTab1 == 0" v-bind:info="modalInfo" />
          <ProjectFolderManage
            ref="projectFolder"
            v-show="currentTab1 == 1"
            v-bind:info="modalInfo"
            @closeModal="closeModal"
          />
          <ProjectMemberManage
            ref="projectMember"
            v-show="currentTab1 == 2"
            v-bind:info="modalInfo"
          />
          <ProjectInvitationManage
            ref="projectInvitation"
            v-if="projectInfo.isInviteUse"
            v-show="currentTab1 == 3"
            v-bind:info="modalInfo"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import ProjectManage from "./ProjectManage";
import ProjectFolderManage from "./ProjectFolderManage";
import ProjectMemberManage from "./ProjectMemberManage";
import ProjectInvitationManage from "./ProjectInvitationManage";
import EventBus from "@/js/eventbus/eventBus";
export default {
  components: {
    ProjectManage,
    ProjectFolderManage,
    ProjectMemberManage,
    ProjectInvitationManage,
  },
  data() {
    return {
      currentTab1: 0,
      tabsTy1: [this.$i18nUtil.trans("title.ProjectManage.001","과제 관리"), this.$i18nUtil.trans("title.ProjectFolderManage.001","과정 관리"), this.$i18nUtil.trans("title.ProjectMemberManage.001","멤버 관리")],
    };
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("project", ["projectInfo"]),
  },
  created() {
    let body = document.querySelector("body");
    body.style.overflow = "hidden";
  },
  mounted() {
    if (this.projectInfo.isInviteUse) {
      this.tabsTy1.push(this.$i18nUtil.trans("title.ProjectInvitationManage.001","가입 요청 관리"));
    }
    if (this.modalInfo.type == "INVITE") {
      this.currentTab1 = 3;
      this.$refs.projectInvitation.searchReset();
      this.$refs.projectInvitation.getInvitationMemberlist();
    } else if (this.modalInfo.type == "MEMBER") {
      this.currentTab1 = 2;
      this.$refs.projectMember.searchReset();
      this.$refs.projectMember.createdList();
    } else {
      this.currentTab1 = 0;
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    tabsClick(index) {
      this.currentTab1 = index;

      if (index == 0) {
      } else if (index == 1) {
        this.$refs.projectFolder.clearSearchFolder();
        // this.$refs.projectFolder.getProjectFolderManageList(false);
      } else if (index == 2) {
        this.$refs.projectMember.searchReset();
        this.$refs.projectMember.createdList();
      } else {
        this.$refs.projectInvitation.searchReset();
        this.$refs.projectInvitation.getInvitationMemberlist();
      }
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      this.$emit("close");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectSetting.vue